import Redactor from '../../../vendor/redactor/redactor';

export default function () {
  const wrapSelector = '.js-cabinet-comment-templates';
  const itemSelector = '.js-cabinet-comment-templates-item';
  const btnSelector = '.js-cabinet-comment-templates-btn';
  const contentSelector = '.js-cabinet-comment-templates-content';
  const resultSelector = '.js-cabinet-comment-templates-result-wysiwyg';

  const wrap = document.querySelector(wrapSelector);
  const result = document.querySelector(resultSelector);

  if (!wrap || !result) return;

  wrap.addEventListener('click', (e) => {
    const btn = e.target.closest(btnSelector);

    if (!btn) return;

    const item = btn.closest(itemSelector);
    const content = item.querySelector(contentSelector);

    Redactor(result, 'insertion.insertHtml', content.innerHTML);
  });
}
